import React from 'react'
import Layout from '../Layout'
import DashboardLayout from '../DashboardLayout'
import Reports from '../../../utils/CommonFunctionality/Reports'
import { useTranslation } from 'react-i18next'

const ReportsManagement = (props) => {
    const { t } = useTranslation()
    return (
        <Layout props={props}>
            <DashboardLayout title={t('report_magement')}>
                <Reports />
            </DashboardLayout>
        </Layout>
    )
}

export default ReportsManagement
